import React from 'react';
import { CartItem } from './cart-item/CartItem';
import { V2LineItem } from '../../interface/checkoutInterface';
import LoadingSpinner from '../shared/LoadingSpinner';
import { NoCartItem } from './cart-item/NoCartItem';
import {
  MarginProps,
  MarginType,
} from '../../../page-builder/puck/reusable-props/margin';
import {
  ReduxDispatchProps,
  ReduxSelectorProps,
} from '../../services/constants';
import {
  getBorderProps,
  getMarginStyles,
  getPaddingStyles,
} from '../../utils/helper';
import { PaddingProps } from '../../puck/reusable-props/padding';
import { IBorderValueProps } from '../../puck/reusable-props/Border';
import { ICardFields } from '../../interface/formInterface';
import { CartLoader } from './cart-item/CartLoader';

export const CartComponent: React.FC<
  MarginProps &
    PaddingProps &
    ReduxSelectorProps &
    ReduxDispatchProps & {
      currentDeviceType: string;
      border: IBorderValueProps;
      colorCustomization: {
        price: string;
        productRemove: string;
        quantityIncreaseIcon: string;
        quantityDecreaseIcon: string;
        quantityDecreaseButton: string;
        quantityIncreaseButton: string;
        quantityBgColor: {
          color: string;
          isInherit: boolean;
        };
        quantityTextColor: string;
      };
      placeholder?: ICardFields;
      productSubtitle?: ICardFields;
      productPricePosition: string;
      background: {
        color: string;
        isInherit: boolean;
      };
      showDescription: boolean;
      showQuantityButtons: boolean;
      cartCustomization: {
        hideImage: boolean;
        hideCloseButton: boolean;
        descriptionPosition: string;
      };
    }
> = ({
  margin,
  useAppSelector,
  useAppDispatch,
  currentDeviceType,
  padding,
  border,
  background,
  placeholder,
  productSubtitle,
  colorCustomization,
  productPricePosition,
  showDescription,
  showQuantityButtons,
  cartCustomization,
}) => {
  const isCartLoading = useAppSelector(state => state.cart.isCartLoading);
  const isCartApiLoading = useAppSelector(state => state.cart.isCartApiLoading);
  const lineItems = useAppSelector(state => state.cart?.cartData?.LineItems);
  const hideProduct = useAppSelector(state => state.common.hideProduct);
  const marginStyles = getMarginStyles(
    margin,
    currentDeviceType as keyof MarginType,
  );
  return (
    <>
      {isCartApiLoading && <CartLoader />}
      <ul
        style={{
          ...marginStyles,
          backgroundColor: background?.isInherit
            ? 'inherit'
            : background?.color,
          ...getPaddingStyles(padding, currentDeviceType),
          ...getBorderProps(border, currentDeviceType),
        }}
        className={`divide-y divide-gray-200 text-sm font-medium text-gray-900 ${border?.borderStyle?.[currentDeviceType]}`}>
        <li className="list-none p-0 m-0">
          <div
            className={`relative w-full ${isCartLoading ? 'opacity-20' : 'opacity-100'}`}>
            {(!lineItems || lineItems?.length === 0) && !isCartApiLoading && (
              <NoCartItem />
            )}
            <ul className="!pl-0">
              {lineItems?.map(
                (product: V2LineItem, index: number) =>
                  hideProduct !== product?.VariantID && (
                    <CartItem
                      key={`${product.VariantID}-${index}`}
                      product={product}
                      useAppDispatch={useAppDispatch}
                      colorCustomization={colorCustomization}
                      useAppSelector={useAppSelector}
                      placeholder={placeholder}
                      productSubtitle={productSubtitle}
                      isSingleProduct={lineItems?.length === 1}
                      productPricePosition={productPricePosition}
                      showDescription={showDescription}
                      showQuantityButtons={showQuantityButtons}
                      cartCustomization={cartCustomization}
                    />
                  ),
              )}
            </ul>
            {isCartLoading && (
              <div className="absolute inset-0 flex items-center justify-center">
                <LoadingSpinner />
              </div>
            )}
          </div>
        </li>
      </ul>
    </>
  );
};
